<div id="search-spinner">
  <div>
    <img src="/assets/images/search-spinner.gif" />
  </div>
</div>
<div id="user-menu" type="popup" [class.active]="isUserPopupOpen" [hidden]="!isUserPopupOpen">
  <a (click)="signOut()">
    <i class="fa fa-lg fa-sign-out"></i>
    {{'main.navigation.sign_out' | translate}}
  </a>
  <a (click)="showCookiePreferences()">
    <i class="fa fa-lg fa-gear"></i>
    {{'main.navigation.cookie_preferences' | translate}}
  </a>
  @if (showCompetitiveDisclaimerLink()) {
    <a (click)="setShowCompetitionDisclaimer()">
      <i class="fa fa-lg fa-warning"></i>
      {{'main.navigation.competition_disclaimer' | translate}}
    </a>
  }
  @if (showGuidedToursOptOut) {
    <a style="display: flex;align-items: center;" (click)="showInApplicationGuidanceSettings()">
      <mat-icon style="height: 16px;width: 16px;font-size: 16px;">language</mat-icon>
      <span style="margin-left: 2px;">{{'main.core.guided-tours.settings.navigation-btn' | translate}}</span>
    </a>
  }
</div>
<!-- Alert Menu Component -->
<div id="alert-menu"
  rdo-alert-menu
  [isOpen]="isAlertPopupOpen"
  [clientId]="alertClientId"
  (alertCountChanged)="onAlertCountChanged($event)">
</div>

<app-competition-disclaimer></app-competition-disclaimer>
<rdo-in-application-guidance-settings></rdo-in-application-guidance-settings>
<header class="box" id="banner">
  @if (clientAttributes?.IsTrial) {
    <div class="trial-mode">
      <div>{{'main.navigation.demo' | translate}}</div>
    </div>
  }

  <div class="logo flex nav-bar">
    @if (brandingService.isLoaded() && !brandingService.logoUrl()) {
      <span>Rouse Services</span>
    }

    @if (brandingService.isLoaded() && brandingService.logoUrl()) {
      <img
        class="client-logo"
        [src]="brandingService.logoUrl()"
        />
    }

    <div class="divider"></div>
    @if (!hasRatesAndAvailability) {
      <span>{{'main.navigation.buttons.rental_dashboard' | translate}}</span>
    }
    @if (hasRatesAndAvailability) {
      <select #ratesAndAvailabilitySelect
        name="ratesAndAvailabilitySelect"
        id="ratesAndAvailabilitySelect"
        class="rates-and-availability-select"
        style="background: rgb(82, 82, 82);"
        (change)="openRatesAndAvailability($event.target.value)"
        >
        <option value="rdo" selected >{{'main.navigation.buttons.rental_dashboard' | translate}}</option>
        <option value="ratesAndAvailability">{{'main.navigation.buttons.rates_and_availability' | translate}}</option>
      </select>
    }
    <div class="divider"></div>
    <span id="client-short-name">{{authenticationService._userInfoView.SelectedClient ? authenticationService._userInfoView.SelectedClient.ClientShortName : ''}}</span>
    <span id="client-id" hidden>{{authenticationService._userInfoView.SelectedClient ? authenticationService.   _userInfoView.SelectedClient.ClientID : ''}}</span>
    <span id="software-version" hidden>{{softwareVersion}}</span>
    <div class="divider"></div>
  </div>

  @if (!isProduction) {
    <div class="db-indicator" (click)="navigateToAdmin()" title="Open Dev Tools">
      <span
        class="db-indicator-badge"
        [class.db-alloydb]="isAlloyDBInUse()"
        [class.db-sqlserver]="!isAlloyDBInUse()"
        >
        {{ isAlloyDBInUse() ? 'AlloyDB (PostgreSQL)' : 'SQL Server (GDB05)' }}
      </span>
    </div>
  }

  <div class="header-searchbox-container">
    <input type="text" id="searchbox" [disabled]="clientAttributes?.IsTrial" class="form-control typeahead"
      placeholder="&#xf002;  {{'main.navigation.search_bar.placeholder' | translate}}" [(ngModel)]="searchCriteria"
      style="font-family: Roboto, sans-serif, FontAwesome;" />
  </div>



  <div class="nav-menuItem" id="market-maps-menu-item" (click)="windowPopup()" data-toggle="tooltip"
    data-placement="bottom" title="{{'main.navigation.buttons.market_maps' | translate}}">
    <a><i class="fa fa-fw fa-map"></i></a>
  </div>

  <div class="nav-menuItem" (click)="windowGuidePopup()" id="user-guide-menu-item" data-toggle="tooltip"
    data-placement="bottom" title="{{'main.navigation.buttons.user_guide' | translate}}">
    <a><i class="fa fa-fw fa-info-circle"></i></a>
  </div>

  <div class="nav-menuItem" id="print-menu-item" onClick="window.print();" data-toggle="tooltip"
    data-placement="bottom" title="{{'main.navigation.buttons.print' | translate}}">
    <a><i class="fa fa-fw fa-print"></i></a>
  </div>

  @if (totalAlerts()) {
    <div class="alerts nav-menuItem" id="alerts-menu-item"
      (click)="toggleAlertPopup()" data-toggle="tooltip" data-placement="bottom" title="{{'main.navigation.alerts.title' | translate}}"
      [class.active]="isAlertPopupOpen">
      <a>@if (totalAlerts() !== alertReadCount) {
        <span class="fa-stack fa-lg" style="position: relative; top: 3px"
          [attr.data-count]="alertCount">
          <i class="fa fa-bell fa-stack-1x fa-inverse"></i>
        </span>
      }
      @if (totalAlerts() === alertReadCount) {
        <i class="fa fa-fw fa-bell"></i>
      }
    </a>
  </div>
}

<div class="clientavatar nav-menuItem" id="client-menu-item" (click)="toggleMulticlientPopup(false)"
  [hidden]="!authenticationService._userInfoView.HasClientSelection" style="display:none;">
  <a style="line-height: 28px;">
    <span>
      {{authenticationService._userInfoView.SelectedClient ? authenticationService._userInfoView.SelectedClient.ClientShortName : ''}}
    </span>
    <i class="fa fa-fw fa-globe"></i>
  </a>
</div>

<div class="avatar nav-menuItem" id="user-menu-item" (click)="toggleUserPopup()" [class.active]="isUserPopupOpen">
  <a style="line-height: 28px;">
    <span>{{authenticationService._userInfoView.ImpersonatedOrCurrentUserFullName}}</span>
    <i class="fa fa-fw fa-user-circle-o"></i>
  </a>
</div>

<button id="reinitializeHeaderButton" (click)="reinitializeHeader()" style="display:none;">
{{'main.navigation.re_initialize' | translate}}</button>
</header>